import RoleListPage from '../views/admin/role/list';
import RoleEditPage from '../views/admin/role/edit';
import UserListPage from '../views/admin/user/list';
import UserEditPage from '../views/admin/user/edit';
import MarketingRegionsListPage from '../views/admin/marketingRegions/list';
import MarketingRegionsEditPage from '../views/admin/marketingRegions/edit';
import {rolePermissions} from 'views/admin/role/permissions';
import {userPermissions} from 'views/admin/user/permissions';
// import {marketingRegionsPermissions} from 'views/admin/marketingRegions/permissions';
import {IRouteItem} from 'routes';

const paths = {
  roleListPage: '/roles',
  roleEditPage: '/roles/:id',
  userListPage: '/users',
  userEditPage: '/users/:id',
  marketingRegionsListPage: '/marketing-regions',
  marketingRegionsEditPage: '/marketing-regions/:id',
};

const routes: IRouteItem[] = [
  {
    name: 'Admin',
    icon: 'gear',
    showInSideBar: true,
    requiredPermissions: [...rolePermissions.ROLE_VIEW.enabled, ...userPermissions.USER_VIEW.enabled],
    children: [
      {
        name: 'Roles',
        path: paths.roleListPage,
        component: RoleListPage,
        breadcrumb: {items: [{text: 'Roles', route: paths.roleListPage}]},
        requiredPermissions: rolePermissions.ROLE_VIEW.enabled,
      },
      {
        name: 'Users',
        path: paths.userListPage,
        component: UserListPage,
        breadcrumb: {items: [{text: 'Users', route: paths.userListPage}]},
        requiredPermissions: userPermissions.USER_VIEW.enabled,
      },
      {
        name: 'Marketing Regions',
        path: paths.marketingRegionsListPage,
        component: MarketingRegionsListPage,
        breadcrumb: {items: [{text: 'Marketing Regions', route: paths.marketingRegionsListPage}]},
        // requiredPermissions: marketingRegionsPermissions.MARKETING_REGIONS_VIEW.enabled,
      },
    ],
  },
  {
    name: 'Role Single',
    path: paths.roleEditPage,
    component: RoleEditPage,
    breadcrumb: {
      items: [
        {text: 'Roles', route: paths.roleListPage},
        {text: 'Edit Role', route: paths.roleEditPage},
      ],
    },
    requiredPermissions: rolePermissions.ROLE_VIEW.enabled,
  },
  {
    name: 'User Single',
    path: paths.userEditPage,
    component: UserEditPage,
    breadcrumb: {
      items: [
        {text: 'Users', route: paths.userListPage},
        {text: 'Edit User', route: paths.userEditPage},
      ],
    },
    requiredPermissions: userPermissions.USER_VIEW.enabled,
  },
  {
    name: 'Marketing Region Single',
    path: paths.marketingRegionsEditPage,
    component: MarketingRegionsEditPage,
    breadcrumb: {
      items: [
        {text: 'Marketing Region', route: paths.marketingRegionsListPage},
        {text: 'Edit Marketing Region', route: paths.marketingRegionsEditPage},
      ],
    },
    // requiredPermissions: marketingRegionsPermissions.MARKETING_REGIONS_VIEW.enabled,
  },
];

export default {
  paths,
  routes,
};
